import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Kontekst integratora super-admina (sidebar). Backend honoruje nagłówek tylko dla
// roli ADMIN, więc wysyłanie go dla innych ról jest nieszkodliwe.
api.interceptors.request.use((config) => {
  try {
    const raw = localStorage.getItem('mm_integrator_context');
    if (raw) {
      const ctx = JSON.parse(raw);
      if (ctx?.id) config.headers['X-Integrator-Context'] = ctx.id;
    }
  } catch { /* uszkodzony wpis w LS — ignoruj */ }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    if (status === 401 || status === 403) {
      const isAuthRoute = error.config?.url?.includes('/api/auth/');
      const hasSession = !!localStorage.getItem('mm_user');
      // 401 = brak/wygasła sesja → wylogowujemy. 403 przy istniejącej sesji = brak uprawnień
      // do KONKRETNEGO zasobu (zła rola) — NIE wylogowujemy, widok pokaże własny błąd.
      if (!isAuthRoute && (status === 401 || !hasSession)) {
        // Wygasła sesja (mieliśmy usera, dostaliśmy 401) → dorzuć flagę, by ekran logowania
        // pokazał komunikat zamiast cichego przeniesienia.
        const expired = status === 401 && hasSession;
        localStorage.removeItem('mm_user');
        window.location.href = expired ? '/login?expired=1' : '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
